export const getCompletions = (state) => {
  return state.autocomplete.completions
}
